import { VideoCameraIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Video = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <VideoCameraIcon size={Sizes[size]} {...rest} />;
};

Video.displayName = 'Video';
